import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

Vue.use(Router)



const main = [
  {
    path: '/',
    // path: '/agent-login',
    name: 'agent-login',
    component: () => import('../views/login/agent_login.vue'),
    meta:{
      title:'登录'
    }
  },
  {
    path: '/agent-findPwd',
    // path: '/agent-login',
    name: 'agent-findPwd',
    component: () => import('../views/login/agent_findPwd.vue'),
    meta:{
      title:'找回密码'
    }
  },
  {
    path: '/agent-personal',
    name: 'agent-personal',
    component: () => import('../views/personal/agent_personal.vue'),
    meta:{
      title:'管理中心'
    }
  },
  {
    path: '/agent-realname',
    name: 'agent-realname',
    component: () => import('../views/personal/agent_realname.vue'),
    meta:{
      title:'实名认证'
    }
  },
  {
    path: '/agent-realname_upload',
    name: 'agent-realname_upload',
    component: () => import('../views/personal/agent_realname_upload.vue'),
    meta: {
      title: '实名认证-手动'
    }
  },
  {
    path: '/agent-personalDetail',
    name: 'agent-personalDetail',
    component: () => import('../views/personal/agent_personal_detail.vue'),
    meta:{
      title:'个人中心-个人信息'
    }
  },
  {
    path: '/agent-personalCash',
    name: 'agent-personalCash',
    component: () => import('../views/userCash/agent_personal_cash.vue'),
    meta:{
      title:'个人中心-提现管理'
    }
  },
  {
    path: '/agent-personalCashAdd',
    name: 'agent-personalCashAdd',
    component: () => import('../views/userCash/agent_personal_cash_add.vue'),
    meta:{
      title:'个人中心-新增提现信息'
    }
  },
  {
    path: '/agent-personalCashAddCard',
    name: 'agent-personalCashAddCard',
    component: () => import('../views/userCash/agent_personal_cash_addCard.vue'),
    meta:{
      title:'个人中心-新增提现信息'
    }
  },
  {
    path: '/agent-personalCashAddSign',
    name: 'agent-personalCashAddSign',
    component: () => import('../views/userCash/agent_personal_cash_addSign.vue'),
    meta:{
      title:'个人中心-新增提现信息'
    }
  },
  {
    path: '/agent-personalCashAddSuccess', 
    name: 'agent-personalCashAddSuccess',
    component: () => import('../views/userCash/agent_personal_cash_addSuccess.vue'),
    meta:{
      title:'个人中心-新增成功'
    }
  },
  {
    path: '/agent-personalCase',
    name: 'agent-personalCase',
    component: () => import('../views/userCash/agent_personal_case.vue'),
    meta:{
      title:'个人中心-签约教程'
    }
  },
  {
    path: '/agent-accountFixedUp',
    name: 'agent-accountFixedUp',
    component: () => import('../views/personal/agent_accountFixedUp.vue'),
    meta:{
      title:'个人中心-信息完善'
    }
  },
  {
    path: '/agent-signUpDoc',
    name: 'agent-signUpDoc',
    component: () => import('../views/personal/agent_signUpDoc.vue'),
    meta:{
      title:'个人中心-合同管理'
    }
  },
  {
    path: '/agent-signUpUi',
    name: 'agent-signUpUi',
    component: () => import('../views/personal/agent_signUpUi.vue'),
    meta:{
      title:'个人中心-合同签约'
    }
  },
  {
    path: '/agent-signUpBind',
    name: 'agent-signUpBind',
    component: () => import('../views/personal/agent_signUpBind.vue'),
    meta:{
      title: '个人中心-绑定已签约账号'
    }
  },
  {
    path: '/agent-uploadSeal',
    name: 'agent-uploadSeal',
    component: () => import('../views/personal/agent_uploadSeal.vue'),
    meta:{
      title:'个人中心-上传印章'
    }
  },
  {
    path: '/agent-notice',
    name: 'agent-notice',
    component: () => import('../views/notice/agent_notice.vue'),
    meta:{
      title:'通知中心'
    }
  },
  {
    path: '/agent-userManage',
    name: 'agent-userManage',
    component: () => import('../views/userManage/agent_manage.vue'),
    meta:{
      title:'客户管理'
    }
  },
  {
    path: '/agent-add',
    name: 'agent-add',
    component: () => import('../views/userManage/agent_add.vue'),
    meta:{
      title:'新增客户'
    }
  },
  {
    path: '/agent-package',
    name: 'agent-package',
    component: () => import('../views/package/agent_package.vue'),
    meta:{
      title:'套餐管理'
    }
  },
  {
    path: '/agent-profit',
    name: 'agent-profit',
    component: () => import('../views/profit/agent_profit.vue'),
    meta:{
      title:'分润管理'
    }
  },
  {
    path: '/agent-userProfit',
    name: 'agent-userProfit',
    component: () => import('../views/profit/agent_userProfit.vue'),
    meta:{
      title:'分润管理'
    }
  },
  {
    path: '/agent-cashin',
    name: 'agent-cashin',
    component: () => import('../views/cashin/agent_cashin.vue'),
    meta:{
      title:'提现管理'
    }
  },
  {
    path: '/agent-cashinAdd',
    name: 'agent-cashinAdd',
    component: () => import('../views/cashin/agent_cashinAdd.vue'),
    meta:{
      title:'新增提现'
    }
  },
  {
    path: '/agent-cashinAddSuccess',
    name: 'agent-cashinAddSuccess',
    component: () => import('../views/cashin/agent_cashinAddSuccess.vue'),
    meta:{
      title:'提现成功'
    }
  },
  {
    path: '/agent-InvoicingInstructions',
    name: 'agent-InvoicingInstructions',
    component: () => import('../views/cashin/agent_InvoicingInstructions.vue'),
    meta:{
      title:'开票需知'
    }
  },
  {
    path: '/agent-cardManage',
    name: 'agent-cardManage',
    component: () => import('../views/card/agent_cardManage.vue'),
    meta:{
      title:'卡片管理'
    }
  },
  {
    path: '/agent-queryCard',
    name: 'agent-queryCard',
    component: () => import('../views/card/agent_queryCard.vue'),
    meta:{
      title:'卡片查询'
    }
  },
  {
    path: '/agent-batchCard',
    name: 'agent-batchCard',
    component: () => import('../views/card/agent_cardHandle.vue'),
    meta:{
      title:'卡片分配'
    }
  },
  {
    path: '/agent-recyclingCard',
    name: 'agent-recyclingCard',
    component: () => import('../views/card/agent_cardHandle.vue'),
    meta:{
      title:'卡片回收'
    }
  },
  {
    path: '/agent-charge',
    name: 'agent-charge',
    component: () => import('../views/charge/agent_charge.vue'),
    meta:{
      title:'余额充值'
    }
  },
  {
    path: '/ancillaryProtocolByUser',
    name: 'ancillaryProtocolByUser',
    component: () => import('../views/ancillaryProtocolByUser/index.vue'),
    meta:{
      title:'附加合同签署'
    }
  }
]

// 分配管理
const distributionRoutes = [
  {
    path:"/distribution",
    name:"distribution",
    component:()=>import('../views/distribution/distribution.vue'),
    meta: {title:"分配管理"},
   },
   {
    path:"/distribution-scan",
    name:"distribution-scan",
    component:()=>import('../views/distribution/distribution_scan.vue'),
    meta: {title:"扫码分配"},
   },
   {
    path:"/distribution-record",
    name:"distribution-record",
    component:()=>import('../views/distribution/distribution_record.vue'),
    meta: {title:"分配明细"},
   },
]


const feedback = [
	{
    	path:"/fb-list",
    	name:"fb-list",
    	component:()=>import('@/views/feedback/fb-list'),
		meta: {title:"反馈"},
   	},
   	{
    	path:"/fb-info",
    	name:"fb-info",
    	component:()=>import('@/views/feedback/fb-info'),
		meta: {title:"反馈详情"},
   	},
   	{
    	path:"/fb-add",
    	name:"fb-add",
    	component:()=>import('@/views/feedback/fb-add'),
		meta: {title:"新增反馈"},
   	},
	{
		path:"/fb-type",
		name:"fb-type",
		component:()=>import('@/views/feedback/fb-type'),
		meta: {title:"问题类型"},
	},
	{
		path:"/fb-new",
		name:"fb-new",
		component:()=>import('@/views/feedback/fb-new'),
		meta: {title:"新增反馈"},
	},
]



const router = new Router({
  mode: 'history',
  routes: [
    ...main,
    ...feedback,
    ...distributionRoutes,
  ]
})

router.beforeEach(async (to, from, next) => {
  console.log('store.state.user.token', store.state.user.token)
  if(Boolean(to.meta.title)){
    document.title = to.meta.title
  }
  if(!Boolean(to.name)){
    next({
      name:'agent-login'
    })
    return
  }
  // 未登录前往非登录页
  if(to.name!='agent-login'&&to.name!='agent-findPwd'&&!Boolean(store.state.user.token)){
    next({
      name:'agent-login'
    })
    return
  }

  // 登录后 前往登录页
  if((to.name=='agent-login'||to.name=='agent-findPwd')&&Boolean(store.state.user.token)){
    console.log('--被拦截')
    next({
      name:'agent-personal'
    })
    return
  }

  next()
  return
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js